var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VBtn',{attrs:{"color":!!_vm.actual? 'primary': 'light',"depressed":"","small":""},on:{"click":function($event){return _vm.$emit('click')}}},[(!!_vm.actual)?[_vm._v(" "+_vm._s(`Актуальные замечания (${_vm.actual})`)+" ")]:[_vm._v(" "+_vm._s(`История замечаний (${_vm.total})`)+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }